import { useQuery } from '@tanstack/react-query'

import { type IGetBankAccount } from '../../types'
import { useUpFetch } from '../../utils'

export const useGetCompanyBankAccounts = ({ id }: { id: number }) => {
  const upFetch = useUpFetch()

  return useQuery({
    queryFn: async () => upFetch<{ data: IGetBankAccount[] }>(`/companies/${id}/bank-accounts`),
    queryKey: ['companyBankAccounts', id],
  })
}
